import React from 'react'
import styled from 'styled-components'
import Layout from '../components/Layout'
import Block from '../components/Block'
import { padding } from '../styles/global'

const ContentContainer = styled.div`
  ${padding}
  width: 100%;
  max-width: 1440px; /* As defined in global styles */
  margin: 0 auto;
  padding-top: 2rem;
  padding-bottom: 2rem;
`

const DynamicPageTemplate = ({ pageContext }) => {
  const { id, acf = {} } = pageContext
  const blocks = acf.page_content || []

  return (
    <Layout>
      <ContentContainer>
        {blocks.map((block, index) => {
          const blockData = {
            ...block,
            type: block.acf_fc_layout || block.type,
          }

          return <Block key={`${id}-${index}`} data={blockData} />
        })}
      </ContentContainer>
    </Layout>
  )
}

export default DynamicPageTemplate
